import PropTypes from 'prop-types';
import useEdelweissConnect from './useEdelweissConnect';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';

EdelweissConnectInitializer.propTypes = {
	isMobile: PropTypes.func,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
};

function EdelweissConnectInitializer({ children, isMobile }) {
	useEdelweissConnect(isMobile);
	return children;
}

export default withIsMobile(EdelweissConnectInitializer);
